import { createContext, ReactNode, useContext, useMemo, useState } from 'react';
import { RFQStatus } from '@steelbuy/ts-shared';

export interface MyRFQsContextValue {
    myRFQFilter: RFQStatus[];
    setMyRFQFilter: (filter: RFQStatus[]) => void;
    referenceFilter: string;
    setReferenceFilter: (input: string) => void;
}

const defaultValue: MyRFQsContextValue = {
    myRFQFilter: [],
    setMyRFQFilter: () => null,
    referenceFilter: '',
    setReferenceFilter: () => null,
};

const MyRFQsContext = createContext(defaultValue);

export const MyRFQsContextProvider = ({ children }: { children: ReactNode }) => {
    const [myRFQFilter, setMyRFQFilter] = useState<RFQStatus[]>([]);
    const [referenceFilter, setReferenceFilter] = useState<string>('');
    const value = useMemo(
        () => ({
            myRFQFilter,
            setMyRFQFilter,
            referenceFilter,
            setReferenceFilter,
        }),
        [myRFQFilter, setMyRFQFilter, referenceFilter, setReferenceFilter]
    );

    return <MyRFQsContext.Provider value={value}>{children}</MyRFQsContext.Provider>;
};

export const useMyRFQsContext = () => useContext(MyRFQsContext);
